import { Check, X } from 'lucide-react';
import { useExpenseApprovals } from '@/composables/expense/useExpenseApprovals';
import { PageContainer } from '@/components/layout/PageContainer';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { StatusBadge } from '@/components/StatusBadge';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { EmptyState } from '@/components/EmptyState';
import { formatDate, formatCurrency } from '@/lib/formatters';

export function ExpenseApprovalsPage() {
  const { pendingApprovals, isLoading, approveExpense, rejectExpense } = useExpenseApprovals();

  if (isLoading) return <LoadingSpinner />;

  return (
    <PageContainer title="Expense Approvals" description="Review and approve pending expenses">
      {pendingApprovals.length === 0 ? (
        <EmptyState title="No pending approvals" description="All expenses have been reviewed" />
      ) : (
        <div className="space-y-4">
          {pendingApprovals.map((expense) => (
            <Card key={expense.id}>
              <CardContent className="p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-medium">{expense.title}</h3>
                    <StatusBadge status={expense.status} type="expense" />
                  </div>
                  <p className="text-sm text-muted-foreground">{expense.createdBy?.firstName} {expense.createdBy?.lastName} - {expense.category?.name} - {formatDate(expense.expenseDate)}</p>
                  {expense.description && <p className="text-sm mt-1">{expense.description}</p>}
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-lg font-bold">{formatCurrency(expense.amount, expense.currency)}</span>
                  <div className="flex gap-2">
                    <Button size="sm" onClick={() => approveExpense.mutate({ id: expense.id })} disabled={approveExpense.isPending}>
                      <Check className="mr-1 h-4 w-4" /> Approve
                    </Button>
                    <Button size="sm" variant="destructive" onClick={() => rejectExpense.mutate({ id: expense.id })} disabled={rejectExpense.isPending}>
                      <X className="mr-1 h-4 w-4" /> Reject
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </PageContainer>
  );
}
